export class SAMLCallback500Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return SAMLCallback500Response.attributeTypeMap;
    }
    constructor() {
    }
}
